
import React, { Component } from 'react'
import { connect } from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import './filterSlidePanel.scss'

// elements
import SlidePanel from '../../../elements/slidePanel'
import BottomBar from '../../../elements/bottomBar'
import Inline from '../../../elements/inline'
import Check from '../../../elements/check'

// Actions
import { closeSlidePanel } from '../../../../actions/common'
import { getEmployees } from '../../../../actions/employees'
import { translation } from '../../../../utils/helpers'
import Avatar from '../../../elements/avatar'

const SparePartStatus = {
  None: 0, // Are ready
  Unknown: 1, // Await order
  NotInUse: 2,
  InStock: 4, // Are ready
  Ordered: 8, // Await receipt
  Received: 16, // Are ready
  Defective: 32,
  Incorrect: 64
}
class FilterSlidePanel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: {
        unassigned: false,
        arrived: false,
        estimationApproved: false,
        sparePartsAreReady: false,
        sparePartsAwaitReception: false,
        sparePartsAreAwaitingOrder: false,
        selectedEmployees: []
      },
      filteredOverview: [],
      originalOverview: [],
      employees: []
      // employeesInRow: []
    }
    this.filterSlidePanel = this.filterSlidePanel.bind(this)
    this.closeFilterSlidePanel = this.closeFilterSlidePanel.bind(this)
    this.updatefilterOverview = this.updatefilterOverview.bind(this)
    this.filterEmployeeFromRows = this.filterEmployeeFromRows.bind(this)
  }

  componentDidMount (props) {
    this.setState({
      originalOverview: this.props.data
    }, () => {
      this.filterSlidePanel()
    })
  }
  componentDidUpdate (previewProps) {
    if (this.props.view !== previewProps.view) {
      if (this.props.view === 'employee' && this.state.employees.length < 1) {
        this.props.getEmployees(this.props.auth.user.ShopId).then((res) => {
          if (Array.isArray(res.data)) {
            let employees = res.data.filter(x => x.Active && x.Confirmed)
            employees.unshift({UserId: 0, Name: translation(17911), Initials: 'UA'}) // add unassign user at the first position.
            this.setState({
              employees: employees
            })
          }
        })
      }
      this.setState({
        originalOverview: previewProps.data
      }, () => {
        this.filterSlidePanel()
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.view !== nextProps.view) {
      let filterStatus = cloneDeep(this.props.filterStatus)
      this.setState({
        filter: filterStatus,
        originalOverview: nextProps.data
      }, () => {
        this.filterSlidePanel()
      })
    }
  }

  filterSlidePanel () {
    let overviewCopy = cloneDeep(this.state.originalOverview)
    overviewCopy = this.props.filterCollection(overviewCopy, this.state.filter)
    this.setState({
      filteredOverview: overviewCopy
    })
  }

  filterEmployeeFromRows (thisEmployee, rows) {
    let count = 0
    let unAssignUser = {UserId: 0}
    rows.map(row => {
      let employeesInRow = []
      row.Assignments.map(assignment => {
        assignment.Employees.map(employee => {
          if (employeesInRow.findIndex(x => x.UserId === employee.UserId) === -1) {
            employeesInRow.push(employee)
            if (thisEmployee.UserId === employee.UserId) {
              count++
            }
          }
        })
      })

       // filter by unassign user
      if (thisEmployee.UserId === 0 && row.HasUnassignedSteps) {
        employeesInRow.push(unAssignUser)
        count++
      }
    })
    return count
  }

  closeFilterSlidePanel () {
    if (this.props.onClose) this.props.onClose()
    this.props.closeSlidePanel('filterOrder')
  }

  updatefilterOverview () {
    let filterCopy = cloneDeep(this.state.filter)
    let filter = { ...this.props.filterStatus, ...filterCopy }
    this.props.filterOverview(filter)
    this.closeFilterSlidePanel()
  }

  renderSparePart () {
    if (this.state.filteredOverview === null) return null
    let filteredOverview = this.state.filteredOverview
    let originalOverview = this.state.originalOverview
    const sparePartsAreReadyCount = originalOverview.Rows.filter(x =>
      x.SparePartStatusSum === SparePartStatus.InStock ||
      x.SparePartStatusSum === SparePartStatus.Received ||
      x.SparePartStatusSum === SparePartStatus.None).length

    const sparePartsAwaitReceptionCount = originalOverview.Rows.filter(x => x.SparePartStatusSum === SparePartStatus.Ordered).length

    const sparePartsAreAwaitingOrderCount = originalOverview.Rows.filter(x => x.SparePartStatusSum === SparePartStatus.Unknown).length

    const renderSpareParts = () => {
      let filter = this.state.filter

      const onChange = (e) => {
        let { name } = e.target
        if (name === 'sparePartsAreReady') {
          filter.sparePartsAreReady = !filter.sparePartsAreReady
        }
        if (name === 'sparePartsAwaitReception') {
          filter.sparePartsAwaitReception = !filter.sparePartsAwaitReception
        }
        if (name === 'sparePartsAreAwaitingOrder') {
          filter.sparePartsAreAwaitingOrder = !filter.sparePartsAreAwaitingOrder
        }

        this.setState({
          filter: filter
        }, () => this.filterSlidePanel())
      }
      const customLabelText = (name) => {
        let className = ''
        let translate = ''
        if (name === 'sparePartsAreReady') {
          className = sparePartsAreReadyCount === 0 && 'disabled-label-text'
          translate = '17919'
        }
        if (name === 'sparePartsAwaitReception') {
          className = sparePartsAwaitReceptionCount === 0 && 'disabled-label-text'
          translate = '17920'
        }
        if (name === 'sparePartsAreAwaitingOrder') {
          className = sparePartsAreAwaitingOrderCount === 0 && 'disabled-label-text'
          translate = '17921'
        }
        return (
          <span className={className}>{translation(translate)}</span>
        )
      }
      return (
        <div>
          <Inline fillChildNum={[0]} block>
            <Check
              name='sparePartsAreReady'
              labelText={customLabelText('sparePartsAreReady')}
              checked={filter.sparePartsAreReady}
              onChange={onChange}
              disabled={sparePartsAreReadyCount === 0}
            />
            <div className='filter-count'>{sparePartsAreReadyCount}</div>
          </Inline>
          <Inline fillChildNum={[0]} block>
            <Check
              name='sparePartsAwaitReception'
              checked={filter.sparePartsAwaitReception}
              labelText={customLabelText('sparePartsAwaitReception')}
              onChange={onChange}
              disabled={sparePartsAwaitReceptionCount === 0}
            />
            <div className='filter-count'>{sparePartsAwaitReceptionCount}</div>
          </Inline>
          <Inline fillChildNum={[0]} block>
            <Check
              name='sparePartsAreAwaitingOrder'
              checked={filter.sparePartsAreAwaitingOrder}
              labelText={customLabelText('sparePartsAreAwaitingOrder')}
              onChange={onChange}
              disabled={sparePartsAreAwaitingOrderCount === 0}
            />
            <div className='filter-count'>{sparePartsAreAwaitingOrderCount}</div>
          </Inline>
        </div>
      )
    }

    const actionText = translation('16656').replace('[count]', filteredOverview.Rows.length)
    return [
      <div className='header top' key={0}>
        <h1 className='title'>{translation('17917')}</h1>
      </div>,
      <div className='content filter' key={1}>
        {renderSpareParts()}
      </div>,

      <BottomBar
        disabled={filteredOverview.Rows.length === 0}
        actionLabelText={actionText}
        onActionClick={() => this.updatefilterOverview('spareParts')}
        cancelLabelText={translation('16444')}
        onCancelClick={this.closeFilterSlidePanel}
        key={2}
      />
    ]
  }

  renderEmployees () {
    if (this.state.filteredOverview === null) return null
    let employees = this.state.employees
    let filteredOverview = this.state.filteredOverview
    let filter = this.state.filter

    const updateFilter = (filter) => {
      this.setState({
        filter: filter
      }, () => {
        this.filterSlidePanel()
      })
    }

    const renderAllEmployees = (employee, key) => {
      let count = this.filterEmployeeFromRows(employee, this.state.originalOverview.Rows)
      key += 1
      const onChange = (e) => {
        const { value, checked } = e.target
        const val = parseInt(value, 10)
        if (checked) {
          filter.selectedEmployees.push(val)
          updateFilter(filter)
        } else {
          filter.selectedEmployees = this.state.filter.selectedEmployees.filter(x => x !== val)
          updateFilter(filter)
        }
      }
      const labelText = () => {
        return (
          <div>
            { /* <Avatar initials={employee.Initials} size='s' disabled={count === 0} />
            <span className={count === 0 && 'disabled-label-text'}>{employee.Name}</span> */ }
            <Avatar initials={employee.Initials} size='s' />
            <span>{employee.Name}</span>
          </div>
        )
      }
      return (
        <div key={key}>
          <Inline fillChildNum={[0]} block >
            <Check
              name={employee.Name}
              value={employee.UserId}
              labelText={labelText()}
              checked={this.state.filter.selectedEmployees.includes(employee.UserId)}
              onChange={onChange}
              // disabled={count === 0}
            />
            <div className='filter-count'>{count}</div>
          </Inline>
        </div>
      )
    }

    const actionText = translation('16656').replace('[count]', filteredOverview.Rows.length
    )
    return [
      <div className='header top' key={0}>
        <h1 className='title'>{translation('17918')}</h1>
      </div>,
      <div className='content filter' key={1}>
        {employees.map(renderAllEmployees)}
      </div>,

      <BottomBar
        disabled={filteredOverview.Rows.length === 0}
        actionLabelText={actionText}
        onActionClick={() => this.updatefilterOverview('spareParts')}
        cancelLabelText={translation('16444')}
        onCancelClick={this.closeFilterSlidePanel}
        key={2}
      />
    ]
  }

  render () {
    let content = null
    switch (this.props.view) {
      case 'spareParts':
        content = this.renderSparePart()
        break
      case 'employee':
        content = this.renderEmployees()
    }
    return (
      <div className='filterSlidePanel'>
        <SlidePanel slidePanelId='filterOrder'>
          {content}
        </SlidePanel>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  closeSlidePanel,
  getEmployees
})(FilterSlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/OrderCapacityOverview/FilterSlidePanel/index.js